var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cruise)?_c('div',{staticClass:"width100"},[_c('h3',[_vm._v("Highlights van deze cruise")]),_vm._l((_vm.getRandomHighlights),function(highlight,index){return _c('p',{key:'RandomHighlight' + index},[_c('font-awesome-icon',{staticClass:"marginright10 icongreen",attrs:{"icon":"check-circle"}}),_vm._v(" "+_vm._s(highlight)+" ")],1)})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }